"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginScreenCont = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.LoginScreenCont = styled_components_1.default.div `
  ${({ theme: { isDesktop, isRTL } }) => isDesktop && `.loginForm {width: 385px}`}
  .iconClose {
    width: 26px;
    height: 26px;
  }
  .loginSideBar {
    width: 320px;
  }
  .borderBottomRadius {
    border-radius:  ${({ theme: { isRTL } }) => (isRTL ? "0 0 8px 0" : "0 0 0 8px")};
  }
`;
